import type { WishlistEntryForm, WishlistForm } from '@occ/api-client';
import { WishListV2, SharedWishlistV2 } from '@occ/api-client';
import { WishListSortOrder } from '@molecules/WishList/WishList';

const wishListApi = new WishListV2({ baseUrl: '' });
const sharedWishlistApi = new SharedWishlistV2({ baseUrl: '' });

export enum WishlistsSortOrder {
  LAST_UPDATED_DESC = 'LAST_UPDATED_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
}

export const getUserWishlists = async (sorting = WishlistsSortOrder.LAST_UPDATED_DESC) => {
  const response = await wishListApi.getUserWishListsV2({ basic: true, sorting });
  return response.data;
};

export const createNewWishList = (form: WishlistForm) => wishListApi.createUserWishlistV2(form);

export const getUserWishList = (id: string) => wishListApi.getUserWishlistV2(id);

export const updateWishList = (id: string, wishListForm: WishlistForm) =>
  wishListApi.updateWishlistV2(id, wishListForm);

export const wishListAddToCart = (id: string, wishListForm: WishlistForm) =>
  wishListApi.addProductsToCartFromWishListV2(id, wishListForm, {});

export const deleteWishList = (id: string) => wishListApi.deleteUserWishListV2(id);

export const deleteMultipleWishLists = (wishListIds: string[]) => wishListApi.deleteUserWishListsV2(wishListIds);

export const updateWishListSorting = (id: string, sorting: WishListSortOrder) =>
  wishListApi.updateWishlistSortingV2(id, { sorting });

export const checkEntriesInWishList = (id: string, wishlistForm: WishlistForm) =>
  wishListApi.checkEntriesInUserWishlistV2(id, wishlistForm);

export const getWishListEntriesStatus = (wishlistForm: WishlistForm, signal: AbortSignal) =>
  wishListApi.validateWishlistEntriesV2(wishlistForm, {}, { signal });

export const removeEntriesFromWishList = (id: string, identifiers: string[]) =>
  wishListApi.removeEntriesFromUserWishlistV2(id, identifiers);

export const getListStatus = (listID: string) => wishListApi.validateWishlistOrderEntriesV2(listID, {});

export const addToUserWishlist = async (id: string, productData: Array<WishlistEntryForm>) => {
  const form = makeForm(productData);
  const response = await wishListApi.addProductsToUserWishlistV2(id, form, { increment: true });
  return response.data;
};

export const shareWishList = (id: string) => sharedWishlistApi.shareWishlistV2(id);

export const getSharedWishList = async (id: string) => {
  const response = await sharedWishlistApi.getSharedWishlistV2(id);
  return response.data;
};

const makeForm = (productData: Array<WishlistEntryForm>, listName?: string) => {
  const entries = productData.map((p) => {
    const { entryType, pickUnit, productCode, promotionCode, quantity } = p;
    if (entryType === 'PROMOTION') {
      return { entryType, pickUnit, productCode, promotionCode, quantity };
    }
    return { entryType, pickUnit, productCode, quantity };
  });
  return listName ? { name: listName, entries } : { entries };
};
